// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for src/pages/Payouts.jsx
 * Loaded AFTER index.css (imported at top of Payouts.jsx), so equal-specificity
 * rules here win by source order. Desktop styles are unchanged.
 *
 * Breakpoints (project standard):
 *   mobile  : max-width 576px
 *   tablet  : 577px – 991px
 *   laptop  : 992px – 1280px
 *   desktop : min-width 1281px
 */

/* ===========================================================================
 * TABLET (577px – 991px): gentle reflow
 * ======================================================================== */
@media (max-width: 991px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ===========================================================================
 * MOBILE (<=576px): full app-like treatment
 * ======================================================================== */
@media (max-width: 576px) {

  /* --- Page header: stack title + button, button full-width -------------- */
  .payouts-page .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .payouts-page .page-header .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* --- Balance card: stack content & stats vertically ------------------- */
  .payouts-page .balance-card {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .payouts-page .balance-stats {
    flex-direction: row;
    justify-content: space-between;
    gap: 0;
    width: 100%;
  }

  .payouts-page .balance-stat {
    align-items: flex-start;
  }

  .payouts-page .balance-amount {
    font-size: 1.6rem;
  }

  /* --- Stats grid: 2 columns on mobile ---------------------------------- */
  .payouts-page .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .payouts-page .stat-card {
    padding: 1rem;
  }

  .payouts-page .stat-icon {
    width: 40px;
    height: 40px;
  }

  .payouts-page .stat-value {
    font-size: 1.25rem;
  }

  /* --- Status tabs: scrollable row, no wrap ----------------------------- */
  .payouts-page .status-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    gap: 0;
    padding-bottom: 0;
  }

  .payouts-page .status-tabs::-webkit-scrollbar {
    display: none;
  }

  .payouts-page .status-tab {
    white-space: nowrap;
    min-height: 44px;
    padding: 0.625rem 0.875rem;
    flex-shrink: 0;
  }

  /* --- Table toolbar: wrap controls ------------------------------------- */
  .payouts-page .table-toolbar {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .payouts-page .toolbar-actions {
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-end;
  }

  .payouts-page .btn-toolbar {
    min-height: 44px;
  }

  .payouts-page .btn-clear-filters {
    min-height: 44px;
  }

  /* --- Payout table: hide as table, show as cards ----------------------- */
  .payouts-page .payout-table-container {
    overflow-x: visible;
    border: none;
    background: transparent;
  }

  .payouts-page .payout-table {
    display: none;
  }

  /* Card list rendered by .payout-cards (injected via JSX className) */
  .payouts-page .payout-cards {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .payouts-page .payout-card {
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
  }

  .payouts-page .payout-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .payouts-page .payout-card-id {
    font-family: monospace;
    font-size: 0.8rem;
    font-weight: 500;
    color: var(--text-primary);
    word-break: break-all;
    min-width: 0;
  }

  .payouts-page .payout-card-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
  }

  .payouts-page .payout-card-label {
    font-size: 0.75rem;
    color: var(--text-muted);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    flex-shrink: 0;
  }

  .payouts-page .payout-card-value {
    color: var(--text-primary);
    text-align: right;
    min-width: 0;
    word-break: break-word;
  }

  .payouts-page .payout-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.5rem;
    border-top: 1px solid var(--border-color);
    gap: 0.5rem;
  }

  .payouts-page .payout-card-footer .btn-view {
    min-height: 44px;
    min-width: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* --- Pagination: stack info and controls ------------------------------ */
  .payouts-page .pagination-container {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    padding: 0.75rem 0;
  }

  .payouts-page .pagination-info {
    flex-wrap: wrap;
    gap: 0.5rem;
    font-size: 0.8rem;
    justify-content: space-between;
  }

  .payouts-page .page-size-select {
    min-height: 44px;
  }

  .payouts-page .pagination-controls {
    flex-wrap: wrap;
    justify-content: center;
    gap: 4px;
  }

  .payouts-page .pagination-btn,
  .payouts-page .page-number {
    min-width: 44px;
    min-height: 44px;
  }

  /* --- Request detail drawer: full-screen bottom sheet ------------------ */
  .payouts-page .request-detail-drawer {
    width: 100%;
    /* Slide up from bottom instead of in from right */
    top: auto;
    bottom: 0;
    height: 92vh;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.2);
    animation: payout-drawer-up 0.3s ease-out;
    padding-bottom: env(safe-area-inset-bottom);
  }

  @keyframes payout-drawer-up {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }

  /* Drag handle affordance */
  .payouts-page .request-detail-drawer::before {
    content: '';
    display: block;
    width: 40px;
    height: 4px;
    background: var(--border-color);
    border-radius: 2px;
    margin: 0.5rem auto -0.25rem;
  }

  /* --- Create payout modal: full-width bottom sheet -------------------- */
  .payouts-page .create-modal {
    position: fixed;
    top: 50%;
    bottom: unset;
    left: 50%;
    right: 0;
    width: 100%;
    max-width: 90%;
    transform: translate(-50%, -50%);
    border-radius: 16px 16px;
    max-height: 92vh;
    display: flex;
    flex-direction: column;
    animation: unset !important;
    padding-bottom: env(safe-area-inset-bottom);
  }

  @keyframes payout-modal-up {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }

  /* Drag handle affordance for modal */
  .payouts-page .create-modal::before {
    content: '';
    display: block;
    width: 40px;
    height: 4px;
    background: var(--border-color);
    border-radius: 2px;
    margin: 0.5rem auto -0.25rem;
  }

  .payouts-page .modal-content {
    overflow-y: auto;
    flex: 1 1;
    max-height: none;
  }

  /* Form row: stack Network + Token fields vertically */
  .payouts-page .form-row {
    grid-template-columns: 1fr;
    gap: 0;
    margin-bottom: 15px;
  }

  /* Full-width inputs and selects */
  .payouts-page .form-group input,
  .payouts-page .form-group select {
    width: 100%;
    min-height: 44px;
    box-sizing: border-box;
  }

  /* Modal footer: stack Cancel + Submit full-width */
  .payouts-page .modal-footer {
    flex-direction: column-reverse;
    gap: 0.5rem;
    padding: 0.875rem 1rem;
  }

  .payouts-page .modal-footer .btn-cancel,
  .payouts-page .modal-footer .btn-confirm {
    width: 100%;
    min-height: 44px;
    text-align: center;
    justify-content: center;
  }

  /* --- Empty state: comfortable padding --------------------------------- */
  .payouts-page .empty-state {
    padding: 2rem 1rem;
    text-align: center;
  }

  .payouts-page .empty-state .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* --- Loading state ---------------------------------------------------- */
  .payouts-page .loading-container {
    padding: 2rem 1rem;
  }
}

/* ==========================================================================
   Payout Requests — toolbar + table panel
   The tabs, the search/range controls, the table and the pager are one card.
   Splitting them across separate surfaces broke the relationship between a
   filter and the rows it filters.
   ========================================================================== */
.payouts-page .po-panel {
  background: var(--ent-card, #fff);
  border: 1px solid var(--ent-border, #eaebf3);
  border-radius: var(--ent-radius, 16px);
  box-shadow: var(--sh-sm, 0 1px 2px rgba(16, 18, 40, 0.05));
  overflow: hidden;
}
/* The wrap already has the panel's border and radius, so it must not draw a
   second one inside it. */
.payouts-page .po-panel .po-table-wrap {
  border: none;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
}
.payouts-page .po-panel .pager {
  padding: 14px 16px;
  background: var(--ent-card-alt, #fbfbfe);
}

/* ---- toolbar ---- */
.payouts-page .po-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 0;
}
.payouts-page .po-toolbar .ent-search { flex: 1 1 260px; min-width: 180px; }
.payouts-page .po-toolbar .ent-search input { width: 100%; }

/* Range picker. A native <select> keeps keyboard and mobile behaviour for
   free; the chevron is ours because the native arrow cannot be styled. */
.payouts-page .po-range {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--ent-border-strong, #dddfec);
  border-radius: var(--r-sm, 10px);
  background: var(--ent-card, #fff);
  color: var(--ent-text-2, #3b4059);
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.payouts-page .po-range:focus-within {
  border-color: var(--brand-400, #a99cff);
  box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.12);
}
.payouts-page .po-range svg { color: var(--ent-muted, #6c7189); flex: none; }
.payouts-page .po-range select {
  appearance: none;
  -webkit-appearance: none;
  border: none;
  background: transparent;
  font: inherit;
  color: inherit;
  cursor: pointer;
  padding: 0;
  outline: none;
}

.payouts-page .po-iconbtn {
  display: inline-grid;
  place-items: center;
  width: 36px;
  height: 36px;
  flex: none;
  border: 1px solid var(--ent-border-strong, #dddfec);
  border-radius: var(--r-sm, 10px);
  background: var(--ent-card, #fff);
  color: var(--ent-text-2, #3b4059);
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}
.payouts-page .po-iconbtn:hover:not(:disabled) {
  border-color: var(--brand-400, #a99cff);
  color: var(--brand-700, #5847d6);
  background: var(--brand-100, #ece9ff);
}
.payouts-page .po-iconbtn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ---- ID / tx hash cell ---- */
.payouts-page .po-idcell { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
/* Badges ride beside the id rather than under it: stacked, they added a third
   line to a two-line cell and every row with one stood taller than its
   neighbours. */
.payouts-page .po-idcell__top {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}
.payouts-page .po-idcell__id {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--ent-text, #0e1124);
  letter-spacing: -0.01em;
  white-space: nowrap;
}
.payouts-page .po-idcell__top .testnet-badge,
.payouts-page .po-idcell__top .priority-badge { margin: 0; }
.payouts-page .po-idcell__hash {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--ent-muted, #6c7189);
}
/* The unsettled state is a sentence, not data — it must not look copyable. */
.payouts-page .po-idcell__hash--empty {
  font-family: inherit;
  font-style: italic;
  color: var(--t-400, #9aa0b6);
}
.payouts-page .po-copy {
  display: inline-grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: var(--t-400, #9aa0b6);
  cursor: pointer;
  transition: background 0.14s, color 0.14s;
}
.payouts-page .po-copy:hover { background: var(--brand-100, #ece9ff); color: var(--brand-700, #5847d6); }

/* ---- destination cell ---- */
.payouts-page .po-dest { display: flex; align-items: center; gap: 11px; min-width: 0; }
.payouts-page .po-dest__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  line-height: 1.25;
}
.payouts-page .po-dest__asset {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--ent-text, #0e1124);
}
/* Chain names run long ("Sepolia Ethereum", "BNB Smart Chain"), so the column
   is held to a sane width and the name truncates rather than stretching the
   table and squeezing the money columns. */
.payouts-page .po-dest__chain {
  font-size: 12px;
  font-weight: 400;
  color: var(--ent-muted, #6c7189);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}
.payouts-page .po-dest__addr {
  font-size: 12px;
  color: var(--t-400, #9aa0b6);
  white-space: nowrap;
}
.payouts-page .po-date { font-size: 13.5px; font-weight: 500; }

/* The actions header is a label now rather than an empty cell, so it needs the
   same right alignment as the kebab under it. */
.payouts-page .pro-table th.col-kebab { text-align: right; }

@media (max-width: 900px) {
  .payouts-page .po-toolbar { width: 100%; flex-wrap: wrap; padding: 8px 12px 10px; }
  .payouts-page .po-toolbar .ent-search { flex: 1 1 100%; }
  /* Stacked-card mode already repeats the address as a label. */
  .payouts-page .po-dest { flex-wrap: wrap; }
}

/* ---- column proportions ----
   Auto layout gave DESTINATION whatever it asked for and left the four money
   columns fighting over the remainder, so AMOUNT / FEE / NET sat bunched in the
   middle with a gulf beside them. Fixing the narrow columns and letting only
   DESTINATION flex puts the numbers back on a readable rhythm. */
.payouts-page .po-panel .pro-table { width: 100%; }
.payouts-page .po-panel .pro-table th:nth-child(1) { width: 19%; }   /* id / tx hash */
.payouts-page .po-panel .pro-table th:nth-child(2) { width: auto; }  /* destination  */
.payouts-page .po-panel .pro-table th:nth-child(3) { width: 12%; }   /* amount       */
.payouts-page .po-panel .pro-table th:nth-child(4) { width: 8%; }    /* fee          */
.payouts-page .po-panel .pro-table th:nth-child(5) { width: 11%; }   /* net amount   */
.payouts-page .po-panel .pro-table th:nth-child(6) { width: 12%; }   /* status       */
.payouts-page .po-panel .pro-table th:nth-child(7) { width: 11%; }   /* date         */
.payouts-page .po-panel .pro-table th:nth-child(8) { width: 60px; }  /* actions      */

/* Fixed layout clips rather than wraps, so anything that can overflow needs to
   say how. */
.payouts-page .po-panel .pro-table td { overflow: hidden; }
.payouts-page .po-panel .pro-table .ui-status-badge { white-space: nowrap; }

@media (max-width: 1200px) {
  /* Below this the fixed widths start clipping the hash and the chain name;
     hand the table back to auto layout and let it scroll. */
  .payouts-page .po-panel .pro-table { table-layout: auto; }
  .payouts-page .po-panel .po-table-wrap { overflow-x: auto; }
}

/* Refetch (range / status / page / sort): keep the current rows in place and
   dim them until the new ones land, instead of swapping in a skeleton. */
.po-table-wrap {
  transition: opacity 0.15s ease;
}
.po-table-wrap.is-refreshing {
  opacity: 0.55;
  pointer-events: none;
}

/* "Add wallet" action inside the no-wallet warning in the Request Payout modal */
.warning-box.payout-wallet-warning {
  align-items: center;
  flex-wrap: wrap;
}
.payout-wallet-warning__btn {
  margin-left: auto;
}
@media (max-width: 640px) {
  .payout-wallet-warning__btn {
    width: 100%;
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Payouts.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;;6EAE6E;AAC7E;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;;6EAE6E;AAC7E;;EAEE,4EAA4E;EAC5E;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,2EAA2E;EAC3E;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,MAAM;IACN,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,2EAA2E;EAC3E;IACE,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA,2EAA2E;EAC3E;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,MAAM;IACN,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;EAChB;;EAEA,2EAA2E;EAC3E;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,2EAA2E;EAC3E;IACE,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,2EAA2E;EAC3E;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,QAAQ;EACV;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA,2EAA2E;EAC3E;IACE,WAAW;IACX,kDAAkD;IAClD,SAAS;IACT,SAAS;IACT,YAAY;IACZ,4BAA4B;IAC5B,0CAA0C;IAC1C,yCAAyC;IACzC,2CAA2C;EAC7C;;EAEA;IACE,OAAO,2BAA2B,EAAE;IACpC,OAAO,wBAAwB,EAAE;EACnC;;EAEA,2BAA2B;EAC3B;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA,0EAA0E;EAC1E;IACE,eAAe;IACf,QAAQ;IACR,aAAa;IACb,SAAS;IACT,QAAQ;IACR,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,2CAA2C;EAC7C;;EAEA;IACE,OAAO,2BAA2B,EAAE;IACpC,OAAO,wBAAwB,EAAE;EACnC;;EAEA,qCAAqC;EACrC;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,SAAO;IACP,gBAAgB;EAClB;;EAEA,sDAAsD;EACtD;IACE,0BAA0B;IAC1B,MAAM;IACN,mBAAmB;EACrB;;EAEA,kCAAkC;EAClC;;IAEE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,mDAAmD;EACnD;IACE,8BAA8B;IAC9B,WAAW;IACX,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA,2EAA2E;EAC3E;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,2EAA2E;EAC3E;IACE,kBAAkB;EACpB;AACF;;AAEA;;;;;+EAK+E;AAC/E;EACE,iCAAiC;EACjC,4CAA4C;EAC5C,sCAAsC;EACtC,0DAA0D;EAC1D,gBAAgB;AAClB;AACA;0BAC0B;AAC1B;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA,wCAAwC,eAAe,EAAE,gBAAgB,EAAE;AAC3E,8CAA8C,WAAW,EAAE;;AAE3D;yEACyE;AACzE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mDAAmD;EACnD,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;AACA,8BAA8B,gCAAgC,EAAE,UAAU,EAAE;AAC5E;EACE,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mDAAmD;EACnD,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,qCAAqC;AACvC;AACA,qCAAqC,YAAY,EAAE,mBAAmB,EAAE;;AAExE,gCAAgC;AAChC,2BAA2B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAC1F;;gBAEgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;gDACgD,SAAS,EAAE;AAC3D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;AACA,6EAA6E;AAC7E;EACE,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,yCAAyC;AAC3C;AACA,+BAA+B,qCAAqC,EAAE,gCAAgC,EAAE;;AAExG,+BAA+B;AAC/B,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE;AACtF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;;2CAE2C;AAC3C;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;AACA,yBAAyB,iBAAiB,EAAE,gBAAgB,EAAE;;AAE9D;gDACgD;AAChD,wCAAwC,iBAAiB,EAAE;;AAE3D;EACE,4BAA4B,WAAW,EAAE,eAAe,EAAE,sBAAsB,EAAE;EAClF,wCAAwC,cAAc,EAAE;EACxD,8DAA8D;EAC9D,yBAAyB,eAAe,EAAE;AAC5C;;AAEA;;;;iEAIiE;AACjE,qCAAqC,WAAW,EAAE;AAClD,qDAAqD,UAAU,EAAE,IAAI,iBAAiB;AACtF,qDAAqD,WAAW,EAAE,GAAG,iBAAiB;AACtF,qDAAqD,UAAU,EAAE,IAAI,iBAAiB;AACtF,qDAAqD,SAAS,EAAE,KAAK,iBAAiB;AACtF,qDAAqD,UAAU,EAAE,IAAI,iBAAiB;AACtF,qDAAqD,UAAU,EAAE,IAAI,iBAAiB;AACtF,qDAAqD,UAAU,EAAE,IAAI,iBAAiB;AACtF,qDAAqD,WAAW,EAAE,GAAG,iBAAiB;;AAEtF;aACa;AACb,wCAAwC,gBAAgB,EAAE;AAC1D,sDAAsD,mBAAmB,EAAE;;AAE3E;EACE;4DAC0D;EAC1D,qCAAqC,kBAAkB,EAAE;EACzD,yCAAyC,gBAAgB,EAAE;AAC7D;;AAEA;yEACyE;AACzE;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,iFAAiF;AACjF;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,cAAc;EAChB;AACF","sourcesContent":["/*\n * Responsive overrides for src/pages/Payouts.jsx\n * Loaded AFTER index.css (imported at top of Payouts.jsx), so equal-specificity\n * rules here win by source order. Desktop styles are unchanged.\n *\n * Breakpoints (project standard):\n *   mobile  : max-width 576px\n *   tablet  : 577px – 991px\n *   laptop  : 992px – 1280px\n *   desktop : min-width 1281px\n */\n\n/* ===========================================================================\n * TABLET (577px – 991px): gentle reflow\n * ======================================================================== */\n@media (max-width: 991px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* ===========================================================================\n * MOBILE (<=576px): full app-like treatment\n * ======================================================================== */\n@media (max-width: 576px) {\n\n  /* --- Page header: stack title + button, button full-width -------------- */\n  .payouts-page .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .payouts-page .page-header .btn-primary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* --- Balance card: stack content & stats vertically ------------------- */\n  .payouts-page .balance-card {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .payouts-page .balance-stats {\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 0;\n    width: 100%;\n  }\n\n  .payouts-page .balance-stat {\n    align-items: flex-start;\n  }\n\n  .payouts-page .balance-amount {\n    font-size: 1.6rem;\n  }\n\n  /* --- Stats grid: 2 columns on mobile ---------------------------------- */\n  .payouts-page .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .payouts-page .stat-card {\n    padding: 1rem;\n  }\n\n  .payouts-page .stat-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .payouts-page .stat-value {\n    font-size: 1.25rem;\n  }\n\n  /* --- Status tabs: scrollable row, no wrap ----------------------------- */\n  .payouts-page .status-tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    gap: 0;\n    padding-bottom: 0;\n  }\n\n  .payouts-page .status-tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .payouts-page .status-tab {\n    white-space: nowrap;\n    min-height: 44px;\n    padding: 0.625rem 0.875rem;\n    flex-shrink: 0;\n  }\n\n  /* --- Table toolbar: wrap controls ------------------------------------- */\n  .payouts-page .table-toolbar {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .payouts-page .toolbar-actions {\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .payouts-page .btn-toolbar {\n    min-height: 44px;\n  }\n\n  .payouts-page .btn-clear-filters {\n    min-height: 44px;\n  }\n\n  /* --- Payout table: hide as table, show as cards ----------------------- */\n  .payouts-page .payout-table-container {\n    overflow-x: visible;\n    border: none;\n    background: transparent;\n  }\n\n  .payouts-page .payout-table {\n    display: none;\n  }\n\n  /* Card list rendered by .payout-cards (injected via JSX className) */\n  .payouts-page .payout-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .payouts-page .payout-card {\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 12px;\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.625rem;\n  }\n\n  .payouts-page .payout-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .payouts-page .payout-card-id {\n    font-family: monospace;\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    word-break: break-all;\n    min-width: 0;\n  }\n\n  .payouts-page .payout-card-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.875rem;\n  }\n\n  .payouts-page .payout-card-label {\n    font-size: 0.75rem;\n    color: var(--text-muted);\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    flex-shrink: 0;\n  }\n\n  .payouts-page .payout-card-value {\n    color: var(--text-primary);\n    text-align: right;\n    min-width: 0;\n    word-break: break-word;\n  }\n\n  .payouts-page .payout-card-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 0.5rem;\n    border-top: 1px solid var(--border-color);\n    gap: 0.5rem;\n  }\n\n  .payouts-page .payout-card-footer .btn-view {\n    min-height: 44px;\n    min-width: 64px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* --- Pagination: stack info and controls ------------------------------ */\n  .payouts-page .pagination-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n    padding: 0.75rem 0;\n  }\n\n  .payouts-page .pagination-info {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    font-size: 0.8rem;\n    justify-content: space-between;\n  }\n\n  .payouts-page .page-size-select {\n    min-height: 44px;\n  }\n\n  .payouts-page .pagination-controls {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 4px;\n  }\n\n  .payouts-page .pagination-btn,\n  .payouts-page .page-number {\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  /* --- Request detail drawer: full-screen bottom sheet ------------------ */\n  .payouts-page .request-detail-drawer {\n    width: 100%;\n    /* Slide up from bottom instead of in from right */\n    top: auto;\n    bottom: 0;\n    height: 92vh;\n    border-radius: 16px 16px 0 0;\n    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.2);\n    animation: payout-drawer-up 0.3s ease-out;\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n\n  @keyframes payout-drawer-up {\n    from { transform: translateY(100%); }\n    to   { transform: translateY(0); }\n  }\n\n  /* Drag handle affordance */\n  .payouts-page .request-detail-drawer::before {\n    content: '';\n    display: block;\n    width: 40px;\n    height: 4px;\n    background: var(--border-color);\n    border-radius: 2px;\n    margin: 0.5rem auto -0.25rem;\n  }\n\n  /* --- Create payout modal: full-width bottom sheet -------------------- */\n  .payouts-page .create-modal {\n    position: fixed;\n    top: 50%;\n    bottom: unset;\n    left: 50%;\n    right: 0;\n    width: 100%;\n    max-width: 90%;\n    transform: translate(-50%, -50%);\n    border-radius: 16px 16px;\n    max-height: 92vh;\n    display: flex;\n    flex-direction: column;\n    animation: unset !important;\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n\n  @keyframes payout-modal-up {\n    from { transform: translateY(100%); }\n    to   { transform: translateY(0); }\n  }\n\n  /* Drag handle affordance for modal */\n  .payouts-page .create-modal::before {\n    content: '';\n    display: block;\n    width: 40px;\n    height: 4px;\n    background: var(--border-color);\n    border-radius: 2px;\n    margin: 0.5rem auto -0.25rem;\n  }\n\n  .payouts-page .modal-content {\n    overflow-y: auto;\n    flex: 1;\n    max-height: none;\n  }\n\n  /* Form row: stack Network + Token fields vertically */\n  .payouts-page .form-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n    margin-bottom: 15px;\n  }\n\n  /* Full-width inputs and selects */\n  .payouts-page .form-group input,\n  .payouts-page .form-group select {\n    width: 100%;\n    min-height: 44px;\n    box-sizing: border-box;\n  }\n\n  /* Modal footer: stack Cancel + Submit full-width */\n  .payouts-page .modal-footer {\n    flex-direction: column-reverse;\n    gap: 0.5rem;\n    padding: 0.875rem 1rem;\n  }\n\n  .payouts-page .modal-footer .btn-cancel,\n  .payouts-page .modal-footer .btn-confirm {\n    width: 100%;\n    min-height: 44px;\n    text-align: center;\n    justify-content: center;\n  }\n\n  /* --- Empty state: comfortable padding --------------------------------- */\n  .payouts-page .empty-state {\n    padding: 2rem 1rem;\n    text-align: center;\n  }\n\n  .payouts-page .empty-state .btn-primary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* --- Loading state ---------------------------------------------------- */\n  .payouts-page .loading-container {\n    padding: 2rem 1rem;\n  }\n}\n\n/* ==========================================================================\n   Payout Requests — toolbar + table panel\n   The tabs, the search/range controls, the table and the pager are one card.\n   Splitting them across separate surfaces broke the relationship between a\n   filter and the rows it filters.\n   ========================================================================== */\n.payouts-page .po-panel {\n  background: var(--ent-card, #fff);\n  border: 1px solid var(--ent-border, #eaebf3);\n  border-radius: var(--ent-radius, 16px);\n  box-shadow: var(--sh-sm, 0 1px 2px rgba(16, 18, 40, 0.05));\n  overflow: hidden;\n}\n/* The wrap already has the panel's border and radius, so it must not draw a\n   second one inside it. */\n.payouts-page .po-panel .po-table-wrap {\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  background: transparent;\n}\n.payouts-page .po-panel .pager {\n  padding: 14px 16px;\n  background: var(--ent-card-alt, #fbfbfe);\n}\n\n/* ---- toolbar ---- */\n.payouts-page .po-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 0;\n}\n.payouts-page .po-toolbar .ent-search { flex: 1 1 260px; min-width: 180px; }\n.payouts-page .po-toolbar .ent-search input { width: 100%; }\n\n/* Range picker. A native <select> keeps keyboard and mobile behaviour for\n   free; the chevron is ours because the native arrow cannot be styled. */\n.payouts-page .po-range {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid var(--ent-border-strong, #dddfec);\n  border-radius: var(--r-sm, 10px);\n  background: var(--ent-card, #fff);\n  color: var(--ent-text-2, #3b4059);\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.payouts-page .po-range:focus-within {\n  border-color: var(--brand-400, #a99cff);\n  box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.12);\n}\n.payouts-page .po-range svg { color: var(--ent-muted, #6c7189); flex: none; }\n.payouts-page .po-range select {\n  appearance: none;\n  -webkit-appearance: none;\n  border: none;\n  background: transparent;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n  padding: 0;\n  outline: none;\n}\n\n.payouts-page .po-iconbtn {\n  display: inline-grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  flex: none;\n  border: 1px solid var(--ent-border-strong, #dddfec);\n  border-radius: var(--r-sm, 10px);\n  background: var(--ent-card, #fff);\n  color: var(--ent-text-2, #3b4059);\n  cursor: pointer;\n  transition: border-color 0.15s, color 0.15s, background 0.15s;\n}\n.payouts-page .po-iconbtn:hover:not(:disabled) {\n  border-color: var(--brand-400, #a99cff);\n  color: var(--brand-700, #5847d6);\n  background: var(--brand-100, #ece9ff);\n}\n.payouts-page .po-iconbtn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ---- ID / tx hash cell ---- */\n.payouts-page .po-idcell { display: flex; flex-direction: column; gap: 2px; min-width: 0; }\n/* Badges ride beside the id rather than under it: stacked, they added a third\n   line to a two-line cell and every row with one stood taller than its\n   neighbours. */\n.payouts-page .po-idcell__top {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n}\n.payouts-page .po-idcell__id {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--ent-text, #0e1124);\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n}\n.payouts-page .po-idcell__top .testnet-badge,\n.payouts-page .po-idcell__top .priority-badge { margin: 0; }\n.payouts-page .po-idcell__hash {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--ent-muted, #6c7189);\n}\n/* The unsettled state is a sentence, not data — it must not look copyable. */\n.payouts-page .po-idcell__hash--empty {\n  font-family: inherit;\n  font-style: italic;\n  color: var(--t-400, #9aa0b6);\n}\n.payouts-page .po-copy {\n  display: inline-grid;\n  place-items: center;\n  width: 20px;\n  height: 20px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  color: var(--t-400, #9aa0b6);\n  cursor: pointer;\n  transition: background 0.14s, color 0.14s;\n}\n.payouts-page .po-copy:hover { background: var(--brand-100, #ece9ff); color: var(--brand-700, #5847d6); }\n\n/* ---- destination cell ---- */\n.payouts-page .po-dest { display: flex; align-items: center; gap: 11px; min-width: 0; }\n.payouts-page .po-dest__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  line-height: 1.25;\n}\n.payouts-page .po-dest__asset {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  min-width: 0;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--ent-text, #0e1124);\n}\n/* Chain names run long (\"Sepolia Ethereum\", \"BNB Smart Chain\"), so the column\n   is held to a sane width and the name truncates rather than stretching the\n   table and squeezing the money columns. */\n.payouts-page .po-dest__chain {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--ent-muted, #6c7189);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 150px;\n}\n.payouts-page .po-dest__addr {\n  font-size: 12px;\n  color: var(--t-400, #9aa0b6);\n  white-space: nowrap;\n}\n.payouts-page .po-date { font-size: 13.5px; font-weight: 500; }\n\n/* The actions header is a label now rather than an empty cell, so it needs the\n   same right alignment as the kebab under it. */\n.payouts-page .pro-table th.col-kebab { text-align: right; }\n\n@media (max-width: 900px) {\n  .payouts-page .po-toolbar { width: 100%; flex-wrap: wrap; padding: 8px 12px 10px; }\n  .payouts-page .po-toolbar .ent-search { flex: 1 1 100%; }\n  /* Stacked-card mode already repeats the address as a label. */\n  .payouts-page .po-dest { flex-wrap: wrap; }\n}\n\n/* ---- column proportions ----\n   Auto layout gave DESTINATION whatever it asked for and left the four money\n   columns fighting over the remainder, so AMOUNT / FEE / NET sat bunched in the\n   middle with a gulf beside them. Fixing the narrow columns and letting only\n   DESTINATION flex puts the numbers back on a readable rhythm. */\n.payouts-page .po-panel .pro-table { width: 100%; }\n.payouts-page .po-panel .pro-table th:nth-child(1) { width: 19%; }   /* id / tx hash */\n.payouts-page .po-panel .pro-table th:nth-child(2) { width: auto; }  /* destination  */\n.payouts-page .po-panel .pro-table th:nth-child(3) { width: 12%; }   /* amount       */\n.payouts-page .po-panel .pro-table th:nth-child(4) { width: 8%; }    /* fee          */\n.payouts-page .po-panel .pro-table th:nth-child(5) { width: 11%; }   /* net amount   */\n.payouts-page .po-panel .pro-table th:nth-child(6) { width: 12%; }   /* status       */\n.payouts-page .po-panel .pro-table th:nth-child(7) { width: 11%; }   /* date         */\n.payouts-page .po-panel .pro-table th:nth-child(8) { width: 60px; }  /* actions      */\n\n/* Fixed layout clips rather than wraps, so anything that can overflow needs to\n   say how. */\n.payouts-page .po-panel .pro-table td { overflow: hidden; }\n.payouts-page .po-panel .pro-table .ui-status-badge { white-space: nowrap; }\n\n@media (max-width: 1200px) {\n  /* Below this the fixed widths start clipping the hash and the chain name;\n     hand the table back to auto layout and let it scroll. */\n  .payouts-page .po-panel .pro-table { table-layout: auto; }\n  .payouts-page .po-panel .po-table-wrap { overflow-x: auto; }\n}\n\n/* Refetch (range / status / page / sort): keep the current rows in place and\n   dim them until the new ones land, instead of swapping in a skeleton. */\n.po-table-wrap {\n  transition: opacity 0.15s ease;\n}\n.po-table-wrap.is-refreshing {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n/* \"Add wallet\" action inside the no-wallet warning in the Request Payout modal */\n.warning-box.payout-wallet-warning {\n  align-items: center;\n  flex-wrap: wrap;\n}\n.payout-wallet-warning__btn {\n  margin-left: auto;\n}\n@media (max-width: 640px) {\n  .payout-wallet-warning__btn {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
